import { render, staticRenderFns } from "./UserSummaryAdmin.vue?vue&type=template&id=78624ba1&"
import script from "./UserSummaryAdmin.vue?vue&type=script&lang=js&"
export * from "./UserSummaryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports